
	import ModeloUpdatePagina from '@/views/paginas/sigap/modelos/ModeloUpdatePagina.vue';   
    import { Options   } from "vue-class-component"; 
    import {  Falta } from "./Falta"; 
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import FaltaService from   "@/service/v1/sigap/FaltaService"  

    @Options({
        name: "FaltaEdicao",
        components: {   },   
    }) 
    export default class FaltaEdicao extends ModeloUpdatePagina {
           
        async created() {  
            this.campos =  Falta.campos();   
            this.service = new FaltaService();   
            await this.buscarStatus();
            await this.buscarMotivo();
            await this.buscarSituacao();
            await this.buscarTipo();
            this.buscaFalta();
        }
 
        public async buscarStatus(){   
            await this.service.getStatus(  ).then(response =>{ 
               this.campos.push(
                    {
                        nome: "status",
                        type: "select",
                        label: "Status",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }
     
        public async buscarSituacao(){   
            await this.service.GetSituacao(  ).then(response =>{ 
               this.campos.push(
                    {
                        nome: "situacao",
                        type: "select",
                        label: "Situação",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }
    
        public async buscarMotivo(){   
            await this.service.getMotivo(  ).then(response =>{ 
               this.campos.push(
                    {
                        nome: "faltaMotivo",
                        type: "select",
                        label: "Motivo",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }
    
        public async buscarTipo(){   
            await this.service.getTipo(  ).then(response =>{ 
               this.campos.push(
                    {
                        nome: "faltaTipo",
                        type: "select",
                        label: "Tipo",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
 
        public buscaFalta(){   
            this.processando = true ; 
            this.service.getModel( this.$route.params.id  ) 
            .then(response => {   
                this.modelo =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public modeloAlterado(){   
            this.formulario = {}
            if(this.modelo){  
                this.service.getModel(this.modelo.id) 
                .then(response => {   
                    this.formulario =  JSON.parse(JSON.stringify( response ));   
                    this.formulario.status = this.formulario.status.id; 
                    this.formulario.faltaMotivo = this.formulario.faltaMotivo.id; 
                    this.formulario.faltaTipo = this.formulario.faltaTipo.id; 
                    this.formulario.situacao = this.formulario.situacao.id; 
                })
                .catch(error => {
                    this.formulario = { };  
                });  
            } 
        }
 
        public sucesso(){  
            this.$router.push({ name: "sigap_falta_show" ,   params: {  id: this.$route.params.id  }  })
        }
        
    } 
